import ztComponent from './ztBreadcrumbs.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
